module.exports = __webpack_public_path__ + "static/media/us.3bdefb41.png";